import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../service/api_service';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { CellDropDownRendererComponent } from '../../Validation/CellDropDownRendererComponent.component';
import { Subscription } from 'rxjs'; 
@Component({
    selector: 'app-edittourprogram',
    template: require('./edittourprogram.component.html'),
    styles: []
})
export class EditTourProgramComponent implements OnInit {
    api: any;
    private gridColumnApi;
    private columnDefs;
    private rowData;
    private rowHeight;
    RouteList: any;
    WorkList: any;
    MonthList: any;
    TPModel: any;
    busy: Subscription;
    empData: any=[];
    newRoute: any;
    rowSelectionMultiple: string;
    selectedItems = [];
    token:any;

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }
    frameworkComponents: any;

    static parameters = [ApiService, Router, ActivatedRoute, ToastrService]
    constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, private toastr: ToastrService) {
        this.frameworkComponents = {
            CustomDropDownRenderer: CellDropDownRendererComponent
        }

        this.rowHeight = 50;
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.rowSelectionMultiple = 'multiple';
        this.MonthList = [
            { "MonthId": 1, "MonthName": "January" },
            { "MonthId": 2, "MonthName": "February" },
            { "MonthId": 3, "MonthName": "March" },
            { "MonthId": 4, "MonthName": "April" },
            { "MonthId": 5, "MonthName": "May" },
            { "MonthId": 6, "MonthName": "June" },
            { "MonthId": 7, "MonthName": "July" },
            { "MonthId": 8, "MonthName": "August" },
            { "MonthId": 9, "MonthName": "September" },
            { "MonthId": 10, "MonthName": "October" },
            { "MonthId": 11, "MonthName": "November" },
            { "MonthId": 12, "MonthName": "December" },
        ];
        var d = new Date();
        this.TPModel = { MonthId: d.getMonth() + 1, "EmployeeCode": "0" };
        this.rowData = [];
        this.InitColumnDef();
        this.getEmployee();
    }

    InitColumnDef() {
        let parent = this;
        this.columnDefs = [
            {
                headerName: 'Action', field: '', width: 50, checkboxSelection: true, headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true
            },
            { headerName: 'Date', field: 'date', width: 200 },
            { headerName: 'Working Option', field: "WorkingOption", width: 150 },
            { headerName: 'Old Work With', field: "Old_WorkWith", width: 300 },
            {
                headerName: "New Work With", field: "New Work With", width: 350
                , cellClass: 'multiselect-dropdown'
                , cellRenderer: 'CustomDropDownRenderer',
                cellRendererParams: {
                    onClick: parent.WorkWithChange.bind(this),
                    dropdownList: parent.WorkList
                }
            },
            { headerName: 'old Route', field: "Old_Route", width: 450 },
            {
                headerName: "New Route",
                field: "New Route",
                width: 350,
                cellRenderer: function (params) {
                    var rowIndex = params.rowIndex;
                    var id = "RouteList" + "-" + rowIndex;
                    var eSelect = document.createElement("select");
                    //Set attributes   
                    eSelect.setAttribute('class', 'form-control ng-valid ng-dirty ng-touched');
                    eSelect.setAttribute('style', 'padding:10px');
                    eSelect.setAttribute('name', "RouteList");
                    eSelect.setAttribute('id', id);
                    eSelect.onchange = function (event: any) {
                        params.data.New_RouteId = Number(event.target.value);
                    };
                    var eOption = document.createElement("option");
                    eOption.text = "Select";
                    eOption.value = "0";
                    eSelect.appendChild(eOption);
                    parent.RouteList.forEach(e => {
                        var eOption = document.createElement("option");
                        eOption.text = e.RouteName;
                        eOption.value = e.RouteId;
                        eSelect.appendChild(eOption);
                    });
                    return eSelect;
                }
            }
        ];
    }

    WorkWithChange(param) {
        console.log('param', param);
        var index = this.rowData.map(item => item.TP_ID).indexOf(param.rowData.TP_ID);
        if (index >= 0) {
            var data = [];
            if (Array.isArray(param.event)) {
                data = param.event.map(item => item.ID);
            } else {
                data = [param.event.ID];
            }
            if (param.IsDeSelect == 1 && data.length == 0) {
                this.rowData[index].New_WorkWith_ID = "";
            } else if (param.IsDeSelect == 1) {
                var WorkWith = JSON.parse("[" + this.rowData[index].New_WorkWith_ID + "]");
                data.forEach(item => {
                    var index = WorkWith.indexOf(item);
                    if (index >= 0) {
                        WorkWith.splice(index, 1);
                    }
                });
                this.rowData[index].New_WorkWith_ID = WorkWith.toString();
            } else {
                this.rowData[index].New_WorkWith_ID = data.toString();
            }
        }
    }

    onGridReady(params) {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
        // this.api.showNoRowsOverlay();
        // params.api.sizeColumnsToFit();
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            res.data.filter(data => {
                if (data.EmpActive == '1') {
                    this.empData.push(data);
                }
              })
            
        })
    }

    GetTPListForEdit() {
        var d = new Date();
        var CurMonth = d.getMonth() + 1;
        this.rowData = [];
        if (this.f_ChkNum(this.TPModel.MonthId) < CurMonth) {
            this.toastr.warning("Please Select Current Month");
            return false;
        }
        if (this.TPModel.EmployeeCode == "0") {
            this.toastr.warning("Please Select Employee Name");
            return false;
        }
        //this.api.showLoadingOverlay();
        var Data = { EmpCode: this.TPModel.EmployeeCode, MonthName: this.TPModel.MonthId };
        this.busy = this.apiService.GetTourProgramEditList(Data).subscribe((res: any) => {
            console.log('res', res);
            //this.api.showNoRowsOverlay();
            if (res.status) {
                this.RouteList = res.RouteList;
                this.WorkList = res.WorkWithList;
                this.rowData = res.TPList;
                this.InitColumnDef();

            }
        })
    }

    SaveAndApprove() {
        let Return ="";
        var data = this.api.getSelectedRows();
        if (data.length == 0) {
            this.toastr.warning("Please Select Tour Plan From List");
            return false;
        }
        data.forEach(ele => {
            if(ele.New_RouteId == 0){
                this.toastr.warning(`Please Select New Route For ${ele.date}`);
                Return ="true";
                return false;  
            } else {
                Return ="false"; 
            }
        });
        if(Return =="false"){
            let token = JSON.parse(sessionStorage.getItem("currentUser"));
            var Data = { data: data, ApprovedBy: token.clientId };
            this.busy = this.apiService.SaveAndApproveTourProgramList(Data).subscribe((res: any) => {
                console.log('res', res);
                if (res.entity[0].flag == 1) {
                    this.GetTPListForEdit();
                    this.toastr.success(res.entity[0].msg);
                } else {
                    this.toastr.error(res.entity[0].msg);
                }
            })
        }
    }

}
